(function () {
  'use strict';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Self-contained canvas confetti engine — no external libraries. Covers
  // the given rect (typically the cart drawer's visible box) for a
  // configurable duration, then removes itself. Called once, on the
  // moment the bar transitions from "not fully unlocked" to "fully
  // unlocked". Four selectable styles, each with its own particle
  // behavior; intensity scales particle count.
  function launchConfetti(rect, options) {
    options = options || {};
    var duration = (options.durationSeconds || 6) * 1000;
    var style = options.style || 'classic';
    var intensity = options.intensity || 'bold';
    var intensityMult = intensity === 'light' ? 0.55 : intensity === 'medium' ? 1 : 1.7;

    var canvas = document.createElement('canvas');
    canvas.width = rect.width;
    canvas.height = rect.height;
    canvas.style.cssText =
      'position:fixed;left:' + rect.left + 'px;top:' + rect.top + 'px;' +
      'width:' + rect.width + 'px;height:' + rect.height + 'px;' +
      'pointer-events:none;z-index:99999;';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    if (!ctx) {
      canvas.remove();
      return;
    }

    function vividColor() {
      var hue = Math.floor(Math.random() * 360);
      return 'hsl(' + hue + ', 88%, 58%)';
    }

    var goldPalette = ['#FFD700', '#FFE9A8', '#FFFFFF', '#F2C14E', '#E8B923'];

    var particles = [];
    var baseArea = rect.width * rect.height;

    // ---- style-specific particle factories ----
    function makeClassicParticle() {
      return {
        x: Math.random() * canvas.width,
        y: -20 - Math.random() * canvas.height * 0.6,
        vx: (Math.random() - 0.5) * 3.5,
        vy: 2 + Math.random() * 2.5,
        rotation: Math.random() * 360,
        vr: (Math.random() - 0.5) * 14,
        size: 6 + Math.random() * 7,
        color: vividColor(),
        shape: Math.random() > 0.45 ? 'rect' : 'circle',
        sway: Math.random() * Math.PI * 2,
        gravity: 0.045
      };
    }

    function makeStreamerParticle() {
      return {
        x: Math.random() * canvas.width,
        y: -30 - Math.random() * canvas.height * 0.6,
        vx: (Math.random() - 0.5) * 1.5,
        vy: 1.2 + Math.random() * 1.3,
        rotation: Math.random() * 360,
        vr: (Math.random() - 0.5) * 6,
        size: 14 + Math.random() * 16,
        color: vividColor(),
        shape: 'ribbon',
        sway: Math.random() * Math.PI * 2,
        swayAmp: 1.4 + Math.random() * 1.2,
        gravity: 0.02
      };
    }

    function makeGoldParticle() {
      return {
        x: Math.random() * canvas.width,
        y: -20 - Math.random() * canvas.height * 0.6,
        vx: (Math.random() - 0.5) * 2,
        vy: 1.4 + Math.random() * 1.8,
        rotation: Math.random() * 360,
        vr: (Math.random() - 0.5) * 10,
        size: 3 + Math.random() * 4,
        color: goldPalette[Math.floor(Math.random() * goldPalette.length)],
        shape: 'circle',
        sway: Math.random() * Math.PI * 2,
        gravity: 0.03,
        sparklePhase: Math.random() * Math.PI * 2,
        sparkleSpeed: 3 + Math.random() * 4
      };
    }

    // fireworks: bursts spawned over time from launchBursts(), not a flat
    // upfront pool — see below
    function makeBurstParticle(originX, originY) {
      var angle = Math.random() * Math.PI * 2;
      var speed = 1.5 + Math.random() * 4;
      return {
        x: originX,
        y: originY,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        rotation: Math.random() * 360,
        vr: (Math.random() - 0.5) * 16,
        size: 4 + Math.random() * 5,
        color: vividColor(),
        shape: Math.random() > 0.5 ? 'rect' : 'circle',
        sway: 0,
        gravity: 0.09,
        life: 0
      };
    }

    if (style === 'streamers') {
      var streamerCount = Math.min(70, Math.round((baseArea / 3200) * intensityMult));
      for (var s = 0; s < streamerCount; s++) particles.push(makeStreamerParticle());
    } else if (style === 'gold') {
      var goldCount = Math.min(260, Math.round((baseArea / 900) * intensityMult));
      for (var g = 0; g < goldCount; g++) particles.push(makeGoldParticle());
    } else if (style === 'fireworks') {
      // particles arrive via periodic bursts during the frame loop
    } else {
      var classicCount = Math.min(180, Math.round((baseArea / 2000) * intensityMult));
      for (var c = 0; c < classicCount; c++) particles.push(makeClassicParticle());
    }

    var startTime = null;
    var lastBurstAt = -9999;
    var burstInterval = 550;

    function drawParticle(p, alpha) {
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.translate(p.x, p.y);
      ctx.rotate((p.rotation * Math.PI) / 180);
      ctx.fillStyle = p.color;
      if (p.shape === 'rect') {
        ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
      } else if (p.shape === 'ribbon') {
        ctx.fillRect(-p.size / 6, -p.size, p.size / 3, p.size * 2);
      } else {
        ctx.beginPath();
        ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.restore();
    }

    function frame(ts) {
      if (!startTime) startTime = ts;
      var elapsed = ts - startTime;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      var fadeStart = duration - 900;
      var globalAlpha = elapsed > fadeStart ? Math.max(0, 1 - (elapsed - fadeStart) / 900) : 1;

      if (style === 'fireworks' && elapsed - lastBurstAt > burstInterval && elapsed < duration - 800) {
        lastBurstAt = elapsed;
        var originX = canvas.width * (0.2 + Math.random() * 0.6);
        var originY = canvas.height * (0.15 + Math.random() * 0.35);
        var burstSize = Math.round(24 * intensityMult);
        for (var b = 0; b < burstSize; b++) particles.push(makeBurstParticle(originX, originY));
      }

      particles.forEach(function (p) {
        p.vy += p.gravity;
        var swayX = p.shape === 'ribbon' ? Math.sin(elapsed / 260 + p.sway) * p.swayAmp : Math.sin(elapsed / 300 + p.sway) * 0.6;
        p.x += p.vx + swayX;
        p.y += p.vy;
        p.rotation += p.vr;
        if (p.life !== undefined) p.life += 16;

        var alpha = globalAlpha;
        if (p.sparklePhase !== undefined) {
          alpha *= 0.55 + 0.45 * Math.abs(Math.sin(elapsed / 100 * (p.sparkleSpeed / 4) + p.sparklePhase));
        }
        if (p.life !== undefined) {
          alpha *= Math.max(0, 1 - p.life / 1400);
        }

        drawParticle(p, alpha);
      });

      // drop fireworks particles that have fully faded, to keep the array lean
      if (style === 'fireworks') {
        particles = particles.filter(function (p) { return p.life === undefined || p.life < 1400; });
      }

      if (elapsed < duration && canvas.isConnected) {
        requestAnimationFrame(frame);
      } else {
        canvas.remove();
      }
    }
    requestAnimationFrame(frame);
  }

  function initBar(bar) {
    if (bar.dataset.cdpbInit) return;
    bar.dataset.cdpbInit = 'true';

    var messageTemplate = bar.dataset.messageTemplate || '';
    var completionText = bar.dataset.completionText || '';
    var messageEl = bar.querySelector('[data-cdpb-message]');
    var fillEl = bar.querySelector('[data-cdpb-fill]');
    var trackEl = bar.querySelector('.cdpb__track');
    var tierEls = Array.prototype.slice.call(bar.querySelectorAll('[data-cdpb-tier]'));

    if (!tierEls.length) return;

    // Set colors directly as inline styles on the actual elements instead
    // of relying purely on the CSS custom properties (--cdpb-fill /
    // --cdpb-track) declared on the wrapper. This bypasses the CSS
    // cascade/inheritance path entirely as a more bulletproof guarantee.
    var fillColor = bar.dataset.fillColor;
    var trackColor = bar.dataset.trackColor;
    if (!fillColor) fillColor = getComputedStyle(bar).getPropertyValue('--cdpb-fill').trim();
    if (!trackColor) trackColor = getComputedStyle(bar).getPropertyValue('--cdpb-track').trim();
    if (fillColor) fillEl.style.setProperty('background-color', fillColor, 'important');
    if (trackColor && trackEl) trackEl.style.setProperty('background-color', trackColor, 'important');

    var tiers = tierEls
      .map(function (el) {
        return {
          el: el,
          thresholdCents: Math.round((parseFloat(el.dataset.threshold) || 0) * 100),
          reward: el.dataset.reward || ''
        };
      })
      .sort(function (a, b) {
        return a.thresholdCents - b.thresholdCents;
      });

    var maxThresholdCents = tiers[tiers.length - 1].thresholdCents;
    var trackWrapEl = bar.querySelector('.cdpb__track-wrap');
    var basePadding = 20; // matches the CSS default padding-bottom on .cdpb__track-wrap

    // position each tier marker either proportionally to its $ amount
    // (default) or evenly spaced regardless of amount — proportional can
    // look cramped when thresholds are close together near the start
    var evenSpacing = bar.dataset.tierSpacing === 'even';
    tiers.forEach(function (tier, index) {
      var pct;
      if (evenSpacing) {
        pct = tiers.length > 1 ? (index / (tiers.length - 1)) * 100 : 0;
      } else {
        pct = maxThresholdCents > 0 ? (tier.thresholdCents / maxThresholdCents) * 100 : 0;
      }
      var isLast = index === tiers.length - 1;
      tier.el.classList.toggle('cdpb__tier--end', isLast);
      if (isLast) {
        // anchor to the right edge instead of centering — centering the
        // last marker exactly at 100% pushes half its icon/label past the
        // track's right edge
        tier.el.style.left = 'auto';
        tier.el.style.right = '0';
        tier.el.style.transform = 'translateY(-50%)';
      } else {
        tier.el.style.left = pct + '%';
      }
    });

    // Every tier's icon/label sits at position:absolute, so none of them
    // contribute real height to the page — a label that wraps to 2-3 lines
    // (via the "Label under icon" textarea) would otherwise overlap
    // whatever comes after the bar (e.g. the Product/Total row) instead of
    // pushing it down. Measure the tallest label actually rendered and
    // grow the track-wrap's own bottom padding to match.
    function adjustSpacing() {
      if (!trackWrapEl) return;
      var maxLabelHeight = 0;
      var oneLineHeight = 0;
      tiers.forEach(function (tier) {
        var labelEl = tier.el.querySelector('.cdpb__tier-label');
        if (!labelEl) return;
        var h = labelEl.getBoundingClientRect().height;
        if (h > maxLabelHeight) maxLabelHeight = h;
        var lh = parseFloat(getComputedStyle(labelEl).lineHeight);
        if (lh > oneLineHeight) oneLineHeight = lh;
      });
      if (maxLabelHeight > 0) {
        // 25px = the label's own "top" offset from the track (see CSS);
        // the trailing gap is exactly one line of the label's own text —
        // stays the same whether the label is 1 or 3 lines tall, instead
        // of growing with the label
        var needed = 25 + maxLabelHeight + oneLineHeight * 0.5;
        trackWrapEl.style.paddingBottom = Math.max(needed, basePadding) + 'px';
      }
    }

    adjustSpacing();

    var confettiEnabled = bar.dataset.confettiEnabled !== 'false';
    var confettiStyle = bar.dataset.confettiStyle || 'classic';
    var confettiDuration = parseFloat(bar.dataset.confettiDuration) || 6;
    var confettiIntensity = bar.dataset.confettiIntensity || 'bold';
    var wasFullyUnlocked = false;

    function render(cartTotalCents) {
      var fillPct = maxThresholdCents > 0 ? Math.min((cartTotalCents / maxThresholdCents) * 100, 100) : 0;
      fillEl.style.setProperty('transform', 'scaleX(' + (fillPct / 100) + ')', 'important');
      var nextTier = null;
      tiers.forEach(function (tier) {
        var complete = cartTotalCents >= tier.thresholdCents;
        tier.el.classList.toggle('is-complete', complete);
        if (!complete && !nextTier) nextTier = tier;
      });

      if (!nextTier) {
        messageEl.textContent = completionText;
        messageEl.classList.add('is-complete');
        if (!wasFullyUnlocked && confettiEnabled) {
          var drawerInner = bar.closest('.drawer__inner') || bar.closest('cart-drawer');
          if (drawerInner) {
            launchConfetti(drawerInner.getBoundingClientRect(), {
              style: confettiStyle,
              durationSeconds: confettiDuration,
              intensity: confettiIntensity
            });
          }
        }
        wasFullyUnlocked = true;
      } else {
        var remainingCents = Math.max(nextTier.thresholdCents - cartTotalCents, 0);
        var text = messageTemplate
          .replace('{amount}', formatMoney(remainingCents))
          .replace('{reward}', nextTier.reward);
        messageEl.textContent = text;
        messageEl.classList.remove('is-complete');
        wasFullyUnlocked = false;
      }
    }

    var lastCartTotal = 0;

    function refreshFromCart() {
      if (!bar.isConnected) return; // orphaned instance — no longer on the page, stop updating it

      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          // original_total_price is the subtotal BEFORE cart-level discounts
          // (like Shopify's automatic "$10 off at $X" discount). Using
          // total_price instead would compare against a number that drops
          // the moment the discount applies — a self-defeating threshold.
          var amount = cart.original_total_price != null ? cart.original_total_price : cart.total_price;
          lastCartTotal = amount;
          bar.classList.toggle('cdpb--cart-empty', cart.item_count === 0);
          render(amount);
        })
        .catch(function () {});
    }

    refreshFromCart();

    // re-check total whenever the cart changes anywhere on the page
    document.addEventListener('cart:updated', refreshFromCart);
    document.addEventListener('cart:refresh', refreshFromCart);

    // Self-healing reflow: re-run render() with the last known total on a
    // light interval. This does NOT re-fetch the cart or touch DOM
    // structure — it only re-measures the track's current pixel width and
    // re-applies it, so if the bar was first rendered while its container
    // wasn't fully laid out yet (e.g. mid-open-animation), it corrects
    // itself shortly after without needing to guess the exact moment the
    // drawer became visible.
    setInterval(function () {
      if (!bar.isConnected) return;
      render(lastCartTotal);
      adjustSpacing();
    }, 2500);
  }

  // ---- anchor relocation (same pattern used by the scroll bar) ----

  var ANCHOR_SELECTOR = '[data-cd-blocks-anchor]';
  var savedClones = {};

  function getActiveAnchor() {
    var anchors = document.querySelectorAll(ANCHOR_SELECTOR);
    return anchors[0] || null;
  }

  function relocate() {
    var anchor = getActiveAnchor();

    if (!anchor) {
      // no live anchor anywhere on the page (e.g. cart-drawer markup not
      // present yet) — make sure no orphaned instance is visibly sitting
      // at its raw theme.liquid mount point
      document.querySelectorAll('.cdpb').forEach(function (bar) {
        bar.style.display = 'none';
      });
      return;
    }

    // Group all .cdpb instances currently on the page by their id. The
    // Theme Editor re-renders a section at its ORIGINAL mount point (where
    // {% section %} is called in theme.liquid) on every settings change —
    // it doesn't know we already moved the previous copy into the anchor.
    // So after a save there can be two nodes sharing the same id: the
    // stale one already inside the anchor, and a fresh one back at the
    // mount point with the new settings baked in. Keep only the fresh one.
    var groups = {};
    document.querySelectorAll('.cdpb').forEach(function (bar) {
      (groups[bar.id] = groups[bar.id] || []).push(bar);
    });

    Object.keys(groups).forEach(function (id) {
      var group = groups[id];
      var keeper = group[0];

      if (group.length > 1) {
        // prefer the copy NOT currently sitting in the anchor — that's the
        // freshly re-rendered one; fall back to the last node in the group
        keeper = group.find(function (el) { return !anchor.contains(el); }) || group[group.length - 1];
        group.forEach(function (el) {
          if (el !== keeper) el.remove();
        });
      }

      if (keeper.dataset.enabled === 'false') {
        // section was turned off in the editor — actively remove it from
        // the anchor (it doesn't just disappear on its own) and forget the
        // saved clone so restoreIfMissing() doesn't bring it back
        keeper.remove();
        delete savedClones[id];
        return;
      }

      savedClones[id] = keeper.cloneNode(true);
      // never save the clone in an "already initialized" state — if we did,
      // a later restore would skip initBar() entirely (see the early-return
      // guard at the top of initBar) and the restored bar would sit frozen
      // forever at whatever cart total it happened to show when it was
      // captured, instead of fetching the live total
      delete savedClones[id].dataset.cdpbInit;

      if (!anchor.contains(keeper)) {
        anchor.appendChild(keeper);
      }

      keeper.style.display = '';

      initBar(keeper);
    });

    // sort all blocks (progress bar + any siblings using the same shared
    // anchor, e.g. scroll bar / upsell banner) by their data-order value —
    // only touch the DOM if the order is actually wrong, since re-appending
    // an already-correctly-placed child still counts as a mutation and
    // would otherwise keep re-triggering the observers below in a loop
    var current = Array.prototype.slice.call(anchor.children);
    var desired = current
      .slice()
      .sort(function (a, b) {
        return (parseInt(a.dataset.order, 10) || 0) - (parseInt(b.dataset.order, 10) || 0);
      });
    var alreadyInOrder = current.every(function (el, i) { return el === desired[i]; });
    if (!alreadyInOrder) {
      desired.forEach(function (child) {
        anchor.appendChild(child);
      });
    }
  }

  function restoreIfMissing() {
    var anchor = getActiveAnchor();
    if (!anchor) return;

    Object.keys(savedClones).forEach(function (id) {
      if (!document.getElementById(id)) {
        anchor.appendChild(savedClones[id].cloneNode(true));
        relocate();
      }
    });
  }

  function resync() {
    restoreIfMissing();
    relocate();
  }

  function bootstrap() {
    relocate();

    var anchor = getActiveAnchor();
    if (anchor) {
      var parent = anchor.closest('cart-drawer') || document.body;
      var observer = new MutationObserver(function () {
        restoreIfMissing();
      });
      observer.observe(parent, { childList: true, subtree: true });
    }

    // A closed <cart-drawer> is correctly skipped by getActiveAnchor(),
    // which means the bar only gets placed/initialized once a drawer is
    // genuinely open and laid out. Watching for the drawer's own
    // class/style/open attribute changes turned out not to catch this
    // theme's actual open mechanism (Dawn may toggle open state in a way
    // that doesn't touch those attributes) — so instead, poll lightly for
    // "is there now a live anchor that isn't initialized yet". This is
    // safe from the earlier mutation-feedback-loop issue because
    // relocate() only touches the DOM when something genuinely needs to
    // change (idempotent sort, init-once guard) — it does not blindly
    // mutate on every call.
    setInterval(relocate, 2500);
  }

  // Theme Editor re-renders a section's markup by swapping innerHTML, which
  // means the <script> above never re-executes on its own — but Shopify
  // does dispatch this event every time a section/block is saved or
  // selected in the editor. Re-running relocate() here is what actually
  // catches and dedupes the fresh copy the editor just dropped back at the
  // section's original mount point.
  document.addEventListener('shopify:section:load', relocate);
  document.addEventListener('shopify:section:reorder', relocate);
  document.addEventListener('shopify:block:select', relocate);

  // On the live storefront, adding/updating/removing a cart item replaces
  // cart-drawer's entire innerHTML with fresh server markup — which
  // destroys our already-relocated bar (it lived inside that innerHTML).
  // Re-run resync() on every signal that could mean that just happened.
  document.addEventListener('cart:update', resync);
  document.addEventListener('cart:updated', resync);
  document.addEventListener('cart:refresh', resync);

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    bootstrap();
  } else {
    document.addEventListener('DOMContentLoaded', bootstrap);
  }
  document.addEventListener('prerenderingchange', bootstrap);
  window.addEventListener('pageshow', bootstrap);
})();